import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "reactstrap";
import { useSelector, shallowEqual } from "react-redux";

import useNavMenu from "../../Components/Hooks/UseNavMenu";

// MenuItem bileşeni aynı kalabilir, değişiklik gerekmiyor.
const MenuItem = ({ item, activeMenus, toggleMenu, location }) => {
  const hasSubItems = item.subItems && item.subItems.length > 0;
  const isMenuOpen = activeMenus.includes(item.id);

  const isItemActive = () => {
    if (location.pathname === item.link) return true;
    if (!hasSubItems) return false;

    const findActiveItem = (items) => {
      for (const child of items) {
        if (location.pathname === child.link) return true;
        if (child.subItems && findActiveItem(child.subItems)) return true;
      }
      return false;
    };
    return findActiveItem(item.subItems);
  };

  const active = isItemActive();

  const linkAttributes = {};
  if (hasSubItems) {
    linkAttributes["data-bs-toggle"] = "collapse";
  }

  return (
    <li className={`nav-item ${hasSubItems ? "dropdown" : ""}`}>
      <Link
        to={item.link || "/#"}
        className={`nav-link menu-link ${active ? "active" : ""} ${
          hasSubItems ? "dropdown-toggle" : ""
        }`}
        onClick={(e) => {
          if (hasSubItems) {
            e.preventDefault();
            toggleMenu(item.id);
          }
        }}
        {...linkAttributes}
      >
        {item.icon && <i className={item.icon}></i>}
        <span data-key={`t-${item.label.toLocaleLowerCase("tr")}`}>
          {item.label}
        </span>
      </Link>

      {hasSubItems && (
        <Collapse isOpen={isMenuOpen} className="menu-dropdown">
          <ul className="nav nav-sm flex-column">
            {item.subItems.map((subItem) => (
              <MenuItem
                key={subItem.id}
                item={subItem}
                activeMenus={activeMenus}
                toggleMenu={toggleMenu}
                location={location}
              />
            ))}
          </ul>
        </Collapse>
      )}
    </li>
  );
};

const HorizontalLayout = () => {
  const { userProfile, authLoading } = useSelector(
    (state) => ({
      userProfile: state.auth.isUserData,
      authLoading: state.auth.authCheckLoading,
    }),
    shallowEqual
  );

  const authorizedMenuItems = useNavMenu();
  const location = useLocation();
  const [activeMenus, setActiveMenus] = useState([]);

  useEffect(() => {
    setActiveMenus([]);
  }, [location.pathname]);

  const toggleMenu = (menuId) => {
    setActiveMenus((prev) =>
      prev.includes(menuId)
        ? prev.filter((id) => id !== menuId)
        : [...prev, menuId]
    );
  };

  // ==================== GELİŞTİRİLMİŞ YENİ MANTIK BAŞLANGICI ====================

  // 1. Sadece "gerçek" menü öğelerini (başlık olmayanları) filtrele
  const menuItemsOnly = (authorizedMenuItems || []).filter(
    (item) => !item.isHeader
  );
  const maxVisibleItems = 6; // Doğrudan gösterilecek maksimum menü sayısı
  const menuThreshold = 6; // Bu sayının üzerinde menü varsa "Daha Fazla" gösterilir

  let finalMenuItems = [];

  // 2. "Daha Fazla" menüsünün gerekip gerekmediğine SADECE filtrelenmiş liste üzerinden karar ver
  if (menuItemsOnly.length > menuThreshold) {
    const visibleItems = menuItemsOnly.slice(0, maxVisibleItems);
    const hiddenItems = menuItemsOnly.slice(maxVisibleItems);

    // Hızlı arama için görünür öğelerin ID'lerini bir Set'e alalım
    const visibleItemIds = new Set(visibleItems.map((i) => i.id));

    // 3. Orijinal listeyi dolaşarak son listeyi oluştur.
    // Bu sayede başlıklar doğru yerlerinde kalır.
    (authorizedMenuItems || []).forEach((item) => {
      if (item.isHeader) {
        finalMenuItems.push(item); // Başlığı olduğu gibi ekle
      } else if (visibleItemIds.has(item.id)) {
        finalMenuItems.push(item); // Görünür menü öğesini ekle
      }
      // Gizlenmiş olan menü öğeleri bu adımda atlanmış olur.
    });

    // 4. "Daha Fazla" menüsünü listenin sonuna ekle
    finalMenuItems.push({
      id: "more-menu",
      label: "Daha Fazla",
      icon: "ri-more-2-fill", // İkonu isteğe göre değiştirebilirsiniz
      subItems: hiddenItems,
    });
  } else {
    // "Daha Fazla" menüsü gerekmiyorsa, orijinal listeyi olduğu gibi kullan
    finalMenuItems = authorizedMenuItems || [];
  }
  // ==================== GELİŞTİRİLMİŞ YENİ MANTIK SONU ====================

  if (authLoading || !userProfile) {
    return null;
  }

  return (
    <React.Fragment>
      {/* Her zaman `finalMenuItems` listesini render et */}
      {finalMenuItems.map((item) => {
        if (item.isHeader) {
          return (
            <li key={item.id || item.label} className="menu-title">
              <span>{item.label}</span>
            </li>
          );
        }
        return (
          <MenuItem
            key={item.id}
            item={item}
            activeMenus={activeMenus}
            toggleMenu={toggleMenu}
            location={location}
          />
        );
      })}
    </React.Fragment>
  );
};

export default HorizontalLayout;
